import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vsingleton()
export class DepartmentRoute extends RouteBase {
  prefix = 'panel.api.departments.'

  search() {
    return this.ziggyRoute('search')
  }
}
